<template lang="html">
  <v-dialog v-model="checkconsentDialog" scrollable width="600px" persistent>
    <v-card>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;{{$t('RightSide.header.privatepolicy')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click.native="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text style="height: 550px;">
        <iframe width="500" height="550" style="visibility: visible; justify-content: center; align-items: center; width: 100%;" frameborder='0' :src="url_consent" allow="geolocation"></iframe>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    checkconsentDialog: Boolean,
    url_consent: String
  },
  data () {
    return {
    }
  },
  watch: {
    checkconsentDialog () {
      if (this.checkconsentDialog) {
        // console.log(this.url_consent)
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialogConsent', false)
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/consent/check_consent_dialog.vue